<script setup lang="ts">
import type { ZoomState } from '../../engine/camera/cameraEngine';

const props = defineProps<{ zoom: ZoomState }>();
const emit = defineEmits<{ change: [value: number] }>();

function onInput(e: Event): void {
  emit('change', Number((e.target as HTMLInputElement).value));
}
</script>

<template>
  <div class="zoom-wrap">
    <span class="zoom-label">{{ props.zoom.effective.toFixed(1) }}×</span>
    <input
      class="zoom-slider"
      type="range"
      :min="props.zoom.min"
      :max="props.zoom.max"
      step="0.1"
      :value="props.zoom.effective"
      :aria-label="$t('aria.zoom')"
      @input="onInput"
    />
  </div>
</template>
